import { Box, Skeleton as SkeletonPlaceholder } from '@sendible/design-system/src';
import {
  Container,
  Content,
  InputContainer,
  SkeletonCardsRow,
  SkeletonCard,
  SkeletonCardHeader,
  SkeletonCardBody,
  SkeletonRightAligned,
} from './index.styles';

const Skeleton = () => (
  <Container data-testid="x-connection-loading-skeleton">
    <Content>
      <InputContainer>
        <SkeletonPlaceholder
          height="0.875rem"
          width="7rem"
        />
        <Box
          fullWidth
          margin={['s12', 's0', 's0', 's0']}
        >
          <SkeletonPlaceholder
            height="2.75rem"
            width="100%"
          />
        </Box>
        <SkeletonRightAligned>
          <SkeletonPlaceholder
            height="0.75rem"
            width="60%"
          />
        </SkeletonRightAligned>
      </InputContainer>
      <SkeletonCardsRow>
        {[0, 1].map((index) => (
          <SkeletonCard key={`skeleton-option-${index}`}>
            <SkeletonCardHeader>
              <SkeletonPlaceholder
                shape="circle"
                height="1.125rem"
                width="1.125rem"
              />
              <SkeletonCardBody>
                <SkeletonPlaceholder
                  height="0.75rem"
                  width="45%"
                />
                <SkeletonPlaceholder
                  height="0.75rem"
                  width="75%"
                />
              </SkeletonCardBody>
            </SkeletonCardHeader>
          </SkeletonCard>
        ))}
      </SkeletonCardsRow>
      <InputContainer>
        <SkeletonPlaceholder
          height="0.875rem"
          width="8rem"
        />
        <Box margin={['s8', 's0', 's0', 's0']}>
          <SkeletonPlaceholder
            height="0.75rem"
            width="60%"
          />
        </Box>
        <Box
          fullWidth
          margin={['s12', 's0', 's0', 's0']}
        >
          <SkeletonPlaceholder
            height="2.75rem"
            width="100%"
          />
        </Box>
      </InputContainer>
      <InputContainer>
        <SkeletonPlaceholder
          height="0.875rem"
          width="10rem"
        />
        <Box margin={['s8', 's0', 's0', 's0']}>
          <SkeletonPlaceholder
            height="0.75rem"
            width="70%"
          />
        </Box>
        <Box
          fullWidth
          margin={['s12', 's0', 's0', 's0']}
        >
          <SkeletonPlaceholder
            height="3rem"
            width="100%"
          />
        </Box>
      </InputContainer>
    </Content>
  </Container>
);

export default Skeleton;
